import { useServerDataContext } from '@shared/server_data_context';

export const useInferredRegion = () => {
  const { inferredRegion } = useServerDataContext();
  return inferredRegion;
};
